import { TokenService } from '../../../../../../services/authentication/token.service';
import { LeicaAxiosServiceFactory } from '../../../../../../services/axios/leica-axios-service-factory';
import { LeicaIntegrationItem } from '../../../state/integrations-state';
import { IDeleteIntegrationDialogItemService } from './types';

export class DeleteIntegrationDialogLeicaService implements IDeleteIntegrationDialogItemService {
  constructor(private item: LeicaIntegrationItem) {}

  async deleteIntegration() {
    await LeicaAxiosServiceFactory.instance
      .createConnectionServiceV1()
      .removeSkyMapLeicaConnection({
        path: { skyMapLeicaConnectionId: this.item.model?.id! },
        query: { skyMapAuthToken: new TokenService().get() },
      });
  }
}
